// #region Imports
import { 
	Link,
	useLocation
} from "react-router"
// #endregion

const navItems = [
	{ 
		to: "/", 
		title: "Home", 
		src: "/logo192.png", 
		alt: "Home" 
	},

	{ 
		to: "/archive", 
		title: "Archive", 
		src: "/others/dashboard.svg", 
		alt: "Archive" 
	}
]

const variants = [
    "opacity-20 hover:opacity-20",
    "opacity-85 hover:opacity-100",
]


function BottomBar() {
	const {pathname} = useLocation()

	return (
		<div 
			className="fixed z-50 bg-[#161616] rounded-md bottom-10 p-1.5 flex justify-center items-center gap-2 transition-transform ease-in-out delay-150 "
		>
			{navItems.map(({ 
				to, 
				title, 
				src, 
				alt 
			}) => (
				<Link
					className={`transition-all ${pathname.includes(alt) ? variants[0] : variants[1] }` }
					key={to}
					to={to}
					title={title}
				>
					<img
						className="h-6"
						src={src}
						alt={alt}
						fetchPriority="high"
					/>
				</Link>
			))}
		</div>
	)
}

export default BottomBar
